/**
 * Maximum number of OR/AND filter groups the CRM query endpoint accepts.
 *
 * Keep in sync with the backend cap `MAX_QUERY_FILTER_GROUPS` in
 * `apps/crm_events/core/filters.py` (raised to 25 in the sibling backend
 * issue of this epic). There is no backend->frontend limits plumbing, so this
 * is a deliberately-named literal; if the two drift, the list page now surfaces
 * the resulting /query rejection as an error state rather than an empty table.
 */
export const MAX_QUERY_FILTER_GROUPS = 25;
